var _linearGradient, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssembly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(-.607 0 0 -.607 525.922 30.249)",
    gradientUnits: "userSpaceOnUse",
    x1: 836.63,
    x2: 843.802,
    y1: 36.205,
    y2: 14.48
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.275
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 2c-1.246 3.056-2 5.057-3.391 8.022a21.884 21.884 0 0 0 3.591 3.134 14.858 14.858 0 0 1 -4-2.283c-1.77 3.706-4.554 8.982-10.2 19.127 5.186-2.994 9.012-4.648 12.691-4.966v-.834h-.834v-.837h.834v.837h1.675v-1.679h-1.675v-.834h-.834v-1.674h.834v-.834h1.675v.834h.834v.837h-.837v-.837h-1.672v1.675h1.675v.834h.834v1.678h-.837v.783c3.98.1 8.006 1.772 13.634 5.021-.863-1.589-1.636-3.021-2.372-4.385a25.526 25.526 0 0 0 -4.833-3.333 14.436 14.436 0 0 1 3.858 1.514c-7.48-13.928-8.085-15.78-10.65-21.8zm-5.489 17.179h1.671v.834h.837v5.021h-.837v-2.513h-1.671v2.512h-.838v-5.02h.837zm0 .834v1.675h1.671v-1.675zm7.526-.834h.837v.834h.837v.837h.834v-.837h.837v-.834h.837v5.855h-.837v-4.184h-.837v.837h-.834v-.837h-.837v4.184h-.837z",
    fill: "#0000bf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.881 18.642c-6.069-8.237-7.476-14.876-7.832-16.461a175.217 175.217 0 0 0 7.832 16.461z",
    fill: "#fff",
    fillOpacity: 0.16568
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.051 2.12-.451 1.107c-.159.391-.311.765-.461 1.131s-.3.724-.448 1.077-.3.7-.448 1.053-.3.706-.465 1.066-.329.729-.506 1.111-.362.778-.561 1.193c-.028.057-.061.123-.089.181a21.872 21.872 0 0 0 3.578 3.117 14.879 14.879 0 0 1 -3.989-2.276l-.14.287c-.065.133-.144.283-.212.42l-.106.219c-.878 1.793-2.006 3.984-3.524 6.822 3.551-2 7.381-4.887 14.338-2.4-.349-.661-.67-1.28-.971-1.863s-.581-1.128-.841-1.644-.5-1-.725-1.463-.433-.9-.629-1.313-.38-.818-.554-1.2-.339-.754-.5-1.118-.3-.727-.447-1.081-.291-.709-.434-1.066c-.036-.091-.073-.186-.109-.277-.408-.956-.821-1.945-1.306-3.083z",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssembly);
export default __webpack_public_path__ + "static/media/assembly.3916c1413498086773f2dd87dcf678e5.svg";
export { ForwardRef as ReactComponent };